import React from "react";
import {Dialog} from "src/components/dialogs/Dialog"
import {styles} from "src/components/dialogs/SourceDetailDialogStyle"
import { css } from "aphrodite-jss";
import { SourceDetail, SubjectArea, SJR } from "src/models/SourceDetail";
import { RequestState } from "src/models/RequestState";
import axios from "axios";
import { Api } from "src/core/api";
import { JsonConvert } from "json2typescript";
import { URLBuilder } from "src/core/URLBuilder";

interface ISourceDetailDialogProps {
    isOpen: boolean;
    onClose: any;
    id: string;
    name: string;
}

class SourceDetailDialogState {
    public readonly requestState: RequestState;
    public readonly data: SourceDetail;
    public readonly error: string;

    constructor() {
        this.requestState = RequestState.NOT_ASKED;
        this.data = new SourceDetail;
        this.error = "";
    }

}

export class SourceDetailDialog extends React.Component<ISourceDetailDialogProps, SourceDetailDialogState>{
    

    constructor(props: ISourceDetailDialogProps) {
        super(props);
        this.state = new SourceDetailDialogState();
    }

    public async componentDidUpdate (prevProps: ISourceDetailDialogProps) {
        if(this.props.isOpen !== prevProps.isOpen  && this.props.isOpen === true) {
            //fetch the data
            const id = this.props.id;
            //const id = "0007-9235"; 
            const url = URLBuilder.source_info(id);
            axios.get(url).then((res)=> {
                if(res.status === 200){
                    try{
                        const jsonConvert = new JsonConvert();
                        const sourceDetail = jsonConvert.deserialize(res.data, SourceDetail);
                        const newState = {...this.state, requestState: RequestState.SUCCESS, data: sourceDetail}
                        this.setState(newState)
                    }catch(error) {
                        const newState = {...this.state, requestState: RequestState.ERROR, error: error.toString()}
                        this.setState(newState)
                    }
                }else{
                    const error = res.statusText + ":" + res.data
                    const newState = {...this.state, requestState: RequestState.ERROR, error: error}
                    this.setState(newState)
                }    
            }).catch((err)=>{
                const error = err.toString();
                const newState = {...this.state, requestState: RequestState.ERROR, error: error}
                this.setState(newState)
            });
        }
    }

    public render() {
        let content;           
        if(this.state.requestState === RequestState.SUCCESS){
            const sjr_sorted = this.state.data.sjr.sort((item1: SJR, item2: SJR)=>item2.year - item1.year)
            const top_sjr = sjr_sorted[0];
            content = (
                <div id="content" className={css(styles.content)}  >    
                    <div className={css(styles.title)} >
                        {this.props.name}
                    </div>
                    <div id="publisher" className={css(styles.row)} >
                        <div id="label" >
                            Publisher: 
                        </div>
                        <div>
                            {this.state.data.publisher}
                        </div>
                    </div>

                    <div id="issn" className={css(styles.row)} >
                        <div id="label" >
                            ISSN: 
                        </div>
                        <div>
                            {this.state.data.issn}
                        </div>
                    </div>

                    <div id="e_issn" className={css(styles.row)} >
                        <div id="label" >
                            E-ISSN:
                        </div>
                        <div>
                            {this.state.data.eissn}
                        </div>
                    </div>

                    <div id="cite_score" className={css(styles.row)} >
                        <div id="label" >
                            Citation Score ({this.state.data.citation_score.current_year}): 
                        </div>
                        <div>
                            {this.state.data.citation_score.score_current_year}
                        </div>
                    </div>

                    <div id="sjr" className={css(styles.row)} >
                        <div id="label" >
                            SJR ({top_sjr.year}): 
                        </div>
                        <div>
                            {top_sjr.score}
                        </div>
                    </div>

                    <div id="subject_areas" className={css(styles.subject_areas)} >
                        <div id="label">
                            Subject areas: 
                        </div>
                        <div id="content">
                            {this.state.data.subject_areas.map((subject_area: SubjectArea)=>{return subject_area.area_name}).join(", ")}
                        </div>
                    </div>

                    <a id="btn_view_documents" href={this.state.data.scopus_source_link} target={this.state.data.scopus_source_link} className={css(styles.button)} > 
                        View all documents
                    </a>
                </div>
            ) 
        }else if(this.state.requestState === RequestState.LOADING)  {
            content = (
                <div>
                    Loading
                </div>
            )
        }else if(this.state.requestState === RequestState.ERROR){
            content = (
                <div>
                    {this.state.error}
                </div>
            )
        }

        return (            
            <Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
                <div id="container" className={css(styles.container)}>
                    <React.Fragment>
                        {content}
                    </React.Fragment>
                </div>
            </Dialog>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/dialogs/SourceDetailDialog.tsx